<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
/* 必要なスタイルを記述 */
</style>
